import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { otpVerificationSchema } from '../schemas/otpVerificationSchema';
import { useNavigate } from 'react-router-dom';
import { verifyOtp } from '../api/auth';
import LabeledTextField from '../components/LabeledTextField';
import UserPageLayout from '../components/UserPageLayout';
import { Box, Button, Alert, Stack } from '@mui/material';

const OtpVerificationIdPage = () => {
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError: setFormError,
  } = useForm({
    resolver: zodResolver(otpVerificationSchema),
    defaultValues: {
      otp: '',
    },
  });

  useEffect(() => {
    const savedPhone = localStorage.getItem('resetPhone');
    if (!savedPhone) {
      navigate('/forgot-id');
    } else {
      setPhone(savedPhone);
    }
  }, [navigate]);

  const onSubmit = async (data) => {
    setFormError('root', { message: '' });
    setMessage('');

    try {
      await verifyOtp(phone, data.otp);

      setMessage('認証に成功しました。ID再設定画面へ移動します。');
      setTimeout(() => {
        navigate('/reset-id-phone');
      }, 1500);
    } catch {
      setFormError('root', {
        type: 'manual',
        message: '通信エラー',
      });
    }
  };

  return (
    <UserPageLayout title="OTP認証（メールアドレス再設定）" maxWidth="sm">
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        sx={{
          maxWidth: 'none',
          boxShadow: 'none',
          minHeight: 'fit-content',
          padding: 0,
          mt: '15dvh',
          alignItems: 'flex-start',
        }}
      >
        <LabeledTextField
          label="認証コード"
          id="otp"
          name="otp"
          type="text"
          autoComplete="one-time-code"
          autoFocus
          placeholder="6桁の数字を入力してください"
          register={register}
          error={errors.otp}
          inputProps={{ maxLength: 6 }}
        />

        {errors.root && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {errors.root.message}
          </Alert>
        )}

        {message && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {message}
          </Alert>
        )}

        <Stack direction="column" spacing={2} sx={{ mt: 3, width: '100%' }}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ borderRadius: 5 }}
            disabled={isSubmitting}
          >
            {isSubmitting ? '確認中...' : '認証コード確認'}
          </Button>
        </Stack>
      </Box>
    </UserPageLayout>
  );
};

export default OtpVerificationIdPage;
